import { type ReactNode } from 'react';
import { Card, CardContent, IconButton, Stack, Typography } from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

type MarkInsertCollapsibleCardProps = {
  title: string;
  collapsed: boolean;
  onCollapsedChange: (collapsed: boolean) => void;
  expandDisabled?: boolean;
  children: ReactNode;
};

export default function MarkInsertCollapsibleCard({
  title,
  collapsed,
  onCollapsedChange,
  expandDisabled = false,
  children,
}: MarkInsertCollapsibleCardProps) {
  const toggleCollapsed = () => {
    if (collapsed) {
      if (!expandDisabled) onCollapsedChange(false);
      return;
    }
    onCollapsedChange(true);
  };

  return (
    <Card>
      <CardContent>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ mb: collapsed ? 0 : 1.5, cursor: expandDisabled && collapsed ? 'default' : 'pointer' }}
          onClick={toggleCollapsed}
          role="button"
          tabIndex={0}
          aria-expanded={!collapsed}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              toggleCollapsed();
            }
          }}
        >
          <Typography variant="subtitle1" fontWeight={700}>
            {title}
          </Typography>
          <IconButton
            size="small"
            aria-label={collapsed ? '展開標記面板' : '收合標記面板'}
            disabled={expandDisabled && collapsed}
            onClick={(e) => {
              e.stopPropagation();
              toggleCollapsed();
            }}
          >
            {collapsed ? <ExpandMoreIcon /> : <ExpandLessIcon />}
          </IconButton>
        </Stack>
        {!collapsed && children}
      </CardContent>
    </Card>
  );
}
